import { moonwave } from "./moonwave/react";
import actions from "./actions";
import routes from "./routes";
import view from "./root";
import "@shopify/polaris/build/esm/styles.css";
import "./pages/styles/main.css";
import "./pages/styles/polaris-tweaks.css";

const root = document.body.querySelector("#root");
const app = moonwave().actions(actions()).routes(routes).render(view, root);

app.atom.dispatch("initialize");

window.app = app;
